/**
 * Core: Storage
 * -----------------------------------------------------------------------------
 * Handles local and session storage with added error handling for when quota is
 * exceeded locally.
 *
 */
import { isStorageSupported } from '~/helpers/general'

/**
 * Create a new storage object.
 * @param {String} key - Storage key.
 * @param {String} value - Value to be stored.
 */
export default (key, value) => {

  /**
   * Handle local storage.
   * - Only used for storing, use default functions for retrieving and deleting.
   */
  function local() {
    if (!isStorageSupported('localStorage')) {
      return
    }

    try {
      localStorage.setItem(key, value)
    } catch (error) {
      window.console.error('Error setting localStorage', error)
    }
  }

  /**
   * Handle session storage.
   * - Only used for storing, use default functions for retrieving and deleting.
   */
  function session() {
    if (!isStorageSupported('sessionStorage')) {
      return
    }

    try {
      sessionStorage.setItem(key, value)
    } catch (error) {
      window.console.error('Error setting sessionStorage', error)
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    local,
    session,
  })
}
